import validate from "/opt/harpia/harpiawms-web/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/opt/harpia/harpiawms-web/frontend/src/middleware/01.auth.global.ts";
import _02_45collector_45layout_45global from "/opt/harpia/harpiawms-web/frontend/src/middleware/02.collector-layout.global.ts";
import manifest_45route_45rule from "/opt/harpia/harpiawms-web/frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45collector_45layout_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "dev-access-middleware": () => import("/opt/harpia/harpiawms-web/frontend/src/middleware/devAccessMiddleware.ts")
}